import { API } from "../api/product-api";
import { Dispatch } from "redux";
import PRODUCT_CONSTANTS from "../constants/product-constants";
import * as types from '../types/product-types';

//--------------------SHOP_PRODUCTS--------------------//
const fetchProductCatalogRequest = (): types.IFetchProductCatalogBegin => {
    return {
        type: PRODUCT_CONSTANTS.FETCH_PRODUCT_CATALOG_REQUEST
    }
}

const fetchProductCatalogError = (e: any): types.IFetchProductCatalogError => {
    return {
        type: PRODUCT_CONSTANTS.FETCH_PRODUCT_CATALOG_FAIL,
        error: e
    }
}

const fetchProductCatalogSuccess = (data: any): types.IFetchProductCatalogSuccess => {
    return {
        type: PRODUCT_CONSTANTS.FETCH_PRODUCT_CATALOG_SUCCESS,
        data
    }
}

export const fetchProductCatalog = (page: number, limit: number, categoryFilter: string[]) => {
    return(dispatch: Dispatch) => {
        dispatch(fetchProductCatalogRequest());
        API.getProductCatalog(page, limit, categoryFilter)
        .then((response: any) => {
            dispatch(fetchProductCatalogSuccess(response.data));
        }).catch((error:any) => {
            dispatch(fetchProductCatalogError(error.response));
        });
    }
}

//-----------------------PRODUCT_DETAILS--------------------//
const productDetailsRequest = (): types.IProductDetailsBegin => {
    return {
        type: PRODUCT_CONSTANTS.PRODUCT_DETAILS_REQUEST
    }
}

const productDetailsError = (e: any): types.IProductDetailsError => {
    return {
        type: PRODUCT_CONSTANTS.PRODUCT_DETAILS_FAIL,
        error: e
    }
}

const productDetailsSuccess = (data: any): types.IProductDetailsSuccess => {
    return {
        type: PRODUCT_CONSTANTS.PRODUCT_DETAILS_SUCCESS,
        data
    }
}

export const listProductDetails = (id: string, getFeatured = 0) => {
    return(dispatch: Dispatch) => {
        dispatch(productDetailsRequest());
        API.getProductById(id, getFeatured).then((response: any) => {
            dispatch(productDetailsSuccess(response.data));
        }).catch((error:any) => {
            dispatch(productDetailsError(error.response));
        });
    }
}

//-----------------------FRONT PAGE PRODUCTS--------------------//
const frontPageProductsRequest = (): types.IFetchFrontPageProductsBegin => {
    return {
        type: PRODUCT_CONSTANTS.FETCH_FRONT_PAGE_PRODUCTS_REQUEST
    }
}

const frontPageProductsError = (e: any): types.IFetchFrontPageProductsError => {
    return {
        type: PRODUCT_CONSTANTS.FETCH_FRONT_PAGE_PRODUCTS_FAIL,
        error: e
    }
}

const frontPageProductsSuccess = (data: any): types.IFetchFrontPageProductsSuccess => {
    return {
        type: PRODUCT_CONSTANTS.FETCH_FRONT_PAGE_PRODUCTS_SUCCESS,
        data
    }
}

export const fetchFrontPageProducts = () => {
    return(dispatch: Dispatch) => {
        dispatch(frontPageProductsRequest());
        API.getFrontPageProducts().then((response: any) => {
            dispatch(frontPageProductsSuccess(response.data));
        }).catch((error:any) => {
            dispatch(frontPageProductsError(error.response));
        });
    }
}

/////////////////////////////////////////////////////////////////////

//-----------------------SEARCH_PRODUCT--------------------//
const searchProductRequest = (): types.ISearchProductBegin => {
    return {
        type: PRODUCT_CONSTANTS.SEARCH_PRODUCT_REQUEST
    }
}

const searchProductError = (e: any): types.ISearchProductError => {
    return {
        type: PRODUCT_CONSTANTS.SEARCH_PRODUCT_FAIL,
        error: e
    }
}

const searchProductSuccess = (data: any): types.ISearchProductSuccess => {
    return {
        type: PRODUCT_CONSTANTS.SEARCH_PRODUCT_SUCCESS,
        data
    }
}

export const searchProduct = (keyword: string, page: number) => {
    return(dispatch: Dispatch) => {
        dispatch(searchProductRequest());
        API.searchProduct(keyword, page).then((response: any) => {
            dispatch(searchProductSuccess(response.data)); 
        }).catch((error:any) => {
            dispatch(searchProductError(error.response));
        });
    }
}

//---------CLEAN PRODUCTS REDUCER ---------
const cleanProducts = (): types.ICleanProductCatalog => {
    return {
        type: PRODUCT_CONSTANTS.CLEAN_PRODUCT_CATALOG
    };
}

export const clearProductCatalog = () => {
    return (dispatch: Dispatch) => {
        dispatch(cleanProducts());
    };
}